import L from "leaflet";
import type {} from "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";

declare global {
  interface Window {
    L?: typeof L;
  }
}

/**
 * Geoman is distributed as a browser-global plugin rather than importing its
 * Leaflet peer itself. In a lazy-loaded chunk, that can make it register its
 * init hooks on a different Leaflet instance from the one that creates maps.
 *
 * Webpack's ProvidePlugin binds Geoman's free `L` references to this same
 * module, including later init hooks. Publishing the global alone is not
 * sufficient: another script can replace it after registration. Keep the
 * assignment for legacy plugins and non-webpack environments such as Jest.
 */
if (typeof window !== "undefined") {
  window.L = L;
}

// `require` deliberately runs after the assignment above. A static import is
// evaluated before this module body and reintroduces the chunk-order race.
// eslint-disable-next-line @typescript-eslint/no-var-requires
require("@geoman-io/leaflet-geoman-free");

if (!L.PM) {
  throw new Error("Leaflet-Geoman did not register on the application Leaflet instance");
}

export default L;
